import List from "@/components/list";
import vue from "@/main";
import { Confirm } from "@/components/Confirm";

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const lookChapters = listeners["lookChapters"] || function() {};
  const preview = listeners["preview"] || function() {};
  const changePort = listeners["change-port"] || function() {};
  const updateBook = listeners["updateBook"] || function() {};
  const deleteBook = listeners["deleteBook"] || function() {};
  const statusBook = listeners["statusBook"] || function() {};
  const sharingBook = listeners["sharingBook"] || function() {};
  const infoBook = listeners["infoBook"] || function() {};

  //编辑图书
  function updateFuc(uuid) {
    updateBook(uuid);
  }

  //删除图书
  async function deleteFuc(uuid) {
    try {
      await Confirm(`确认删除该图书吗?`, "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      });
    } catch (error) {
      if (error === "cancel") return;
    }
    deleteBook(uuid);
  }

  //上/下线图书
  async function statusFuc(uuid, status) {
    const text = status === 0 ? "下线" : status === 1 ? "上线" : "";
    try {
      await Confirm(`确认` + text + `该图书吗?`, "系统提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      });
    } catch (error) {
      if (error === "cancel") return;
    }
    statusBook(uuid, status);
  }

  //图书共享管理
  function sharingFuc(uuid) {
    sharingBook(uuid)
  }

  //图书详情
  function infoFuc(uuid) {
    infoBook(uuid);
  }

  //操作列按钮
  const Deal = ({ props: { vo } }) => {
    const book = vo.row;
    const dealConf = [];
    if (book.enableShared === 0 || book.onlineStatus == 1) {
      dealConf.push(["编辑", "book:update", "icon-edit-disable", () => {}]);
      // dealConf.push(["删除", "book:delete", "icon-delete-disable", () => {}]);
    } else {
      dealConf.push([
        "编辑",
        "book:update",
        "icon-edit",
        () => updateFuc(book.uuid),
      ]);
      // dealConf.push([
      //   "删除",
      //   "book:delete",
      //   "icon-delete",
      //   () => deleteFuc(book.uuid)
      // ]);
    }
    if (book.onlineStatus == 1) {
      dealConf.push(["删除", "book:delete", "icon-delete-disable", () => {}]);
    } else {
      dealConf.push([
        "删除",
        "book:delete",
        "icon-delete",
        () => deleteFuc(book.uuid),
      ]);
    }

    if (book.onlineStatus) {
      dealConf.push([
        "下线",
        "book:status",
        "icon-down",
        () => statusFuc(book.uuid, 0),
      ]);
    } else {
      dealConf.push([
        "上线",
        "book:status",
        "icon-up",
        () => statusFuc(book.uuid, 1),
      ]);
    }
    if (book.enableShared === 0) {
      dealConf.push(["共享管理", "book:manage", "icon-share-none", () => {}]);
    } else {
      dealConf.push([
        "共享管理",
        "book:manage",
        "icon-share",
        () => sharingFuc(book.uuid),
      ]);
    }
    dealConf.push([
      "章节列表",
      "",
      "icon_cplist",
      () => {
        lookChapters(vo.row);
      },
    ]);
    dealConf.push([
      "预览",
      "",
      "icon-preview",
      () => {
        preview(vo.row);
      },
    ]);

    dealConf.push([
      "修改展示终端",
      "book:updateDisplay",
      book.onlineStatus == 1
        ? "iconfont icxiugaizhanshizhongduan iconfont-adapt-disabled"
        : "iconfont icxiugaizhanshizhongduan iconfont-adapt",
      book.onlineStatus == 1 ? () => {} : () => changePort(book),
    ]);

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[0]}
            v-permission={item[1]}
            placement="top"
          >
            <i class={item[2]} onClick={item[3]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const ShareForDept = ({ props: { vo } }) => {
    return <span>{vo.row.shareForDept || "--"}</span>;
  };
  const SharedFromDeptName = ({ props: { vo } }) => {
    return <span>{vo.row.sharedFromDeptName || "--"}</span>;
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "图书名称",
      width: "200",
      fixed: "left",
      showOverflowTooltip: true,
      render: (vo) => (
        <el-button
          size="small"
          type="text"
          onClick={() => infoFuc(vo.row.uuid)}
        >
          {vo.row.bookName}
        </el-button>
      ),
    },
    {
      label: "图书分类",
      prop: "categoryName",
      minWidth: "120",
    },
    {
      label: "图书来源",
      prop: "bookSource",
      minWidth: "120",
      showOverflowTooltip: true,
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "120",
    },
    {
      label: "作者",
      prop: "bookAuthor",
      minWidth: "120",
    },
    {
      label: "展示终端",
      prop: "clientNames",
      width: "100",
    },
    {
      label: "已共享学院",
      prop: "shareForDept",
      width: "150",
      render: (vo) => <ShareForDept vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "版权方",
      prop: "sharedFromDeptName",
      minWidth: "120",
      render: (vo) => <SharedFromDeptName vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "130",
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "190",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
